var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"content"},[_c('projects'),_c('crew')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }